/**
 *
 * Simple hook to get the ctx context
 *
 */
import { useContext } from "react";
import { CtpCtx } from "~/lib/ctpApollo";

// hooks
function useCommercetoolsContext() {
  const ctx = useContext(CtpCtx);
  return ctx;
}

export default useCommercetoolsContext;
